<template>
  <section class="app-main dark">
    
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: "receipt",
  data() {
    return {};
  }
  // computed: {
  //   cachedViews() {
  //     return this.$store.state.tagsView.cachedViews;
  //   },
  //   key() {
  //     return this.$route.fullPath;
  //   }
  // }
};
</script>